import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=2b475a14&scoped=true&"
import script from "./CustomerDetail.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=2b475a14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b475a14",
  null
  
)

export default component.exports